import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import _merge from "lodash/merge";
import _compact from "lodash/compact";
import _flattenDeep from "lodash/flattenDeep";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Merges { className, style } objects together into a single object.
 */
var mergeStyles = function mergeStyles() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var _args$reduce = args.reduce(function (memo, _ref) {
    var className = _ref.className,
        style = _ref.style;
    memo.classNameProps.push(className);
    memo.styleProps.push(style);
    return memo;
  }, {
    classNameProps: [],
    styleProps: []
  }),
      classNameProps = _args$reduce.classNameProps,
      styleProps = _args$reduce.styleProps;

  classNameProps = _flattenDeep(_compact(classNameProps));
  styleProps = _flattenDeep(_compact(styleProps));
  return {
    className: classNameProps.length ? classNameProps.join(' ') : undefined,
    style: styleProps.length ? _merge.apply(void 0, [{}].concat(_toConsumableArray(styleProps))) : undefined
  };
};

export default mergeStyles;